import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { GALLERY } from "../lib/blogs";

export const Gallery = () => (
  <section id="photos" className="border-t border-[#262626] bg-[#0A0A0A]" data-testid="gallery-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-36">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-14">
        <Reveal className="lg:col-span-8">
          <span className="overline">Photographs</span>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mt-5 text-[#F7F5F2] text-balance">
            Moments from the practice.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-4">
          <p className="text-[#8C8C8C] leading-relaxed">A glimpse into the work, the chamber and the courts where matters are argued and resolved.</p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {GALLERY.map((g, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className={`group relative overflow-hidden border border-[#262626] ${g.aspect || "aspect-[4/3]"}`}
            data-testid={`gallery-item-${i}`}
          >
            <img
              src={g.src}
              alt={g.label}
              loading="lazy"
              className="w-full h-full object-cover grayscale-[0.35] group-hover:grayscale-0 group-hover:scale-[1.04] transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <span className="absolute bottom-4 left-4 font-mono text-xs uppercase tracking-widest text-[#F7F5F2] opacity-0 group-hover:opacity-100 transition-opacity duration-500">
              {g.label}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
